import { PropsWithChildren, useEffect, useRef } from 'react';

import { useConfidence } from '@spotify-confidence/react';
import {
  type SessionRecorder,
  initSessionRecorder,
} from '@spotify-confidence/session-recording';
import { isTestEnvironment, useAuth } from '@spotify/confidence-core-react';

const IS_E2E_TEST = isTestEnvironment();
const BUILD_COMMIT_HASH = document.querySelector<HTMLMetaElement>(
  'meta[name="build-commit"]',
)?.content;

export function FlagContext({ children }: PropsWithChildren) {
  const { user, isAuthenticated, orgName } = useAuth();
  const confidence = useConfidence();
  const sessionRecorderRef = useRef<SessionRecorder>();

  useEffect(() => {
    confidence.setContext({ ...user });

    if (
      process.env.NODE_ENV === 'production' &&
      !IS_E2E_TEST &&
      !sessionRecorderRef.current &&
      user
    ) {
      sessionRecorderRef.current = initSessionRecorder({
        clientSecret: 'NiAgIVmkjVSTNI5k8mpsgs3EeFqkacrA',
        context: {
          ...confidence.getContext(),
          origin: window.location.origin,
          path: window.location.pathname,
        },
        appVersion: BUILD_COMMIT_HASH,
        blockSelectors: ['[data-csr-block]'],
        maskSelectors: ['[data-csr-mask]'],
        captureConsoleLogs: { levels: ['warn', 'error'] },
        captureNetworkRequests: true,
      });
    }
  }, [user]);

  useEffect(() => {
    if (isAuthenticated) {
      sessionRecorderRef.current?.tag('isAuthenticated', `${isAuthenticated}`);
    }
    if (orgName) {
      sessionRecorderRef.current?.tag('org_name', orgName);
    }
  }, [isAuthenticated, orgName]);

  // TODO wrap children in a ConfidenceProvider.WithContext({...user}) provider
  return <>{children}</>;
}
